var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'loader ' + 'loader--' + _vm.size},_vm._l((3),function(e){return _c('div',{key:e,class:'loader__circle ' + 'loader__circle--' + _vm.size,style:({ backgroundColor: _vm.color })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }